"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var reactstrap_1 = require("reactstrap");
var Services_1 = require("../../../Services");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var Components_1 = require("../../../Components");
var ActionButton = /** @class */ (function (_super) {
    __extends(ActionButton, _super);
    function ActionButton(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {};
        _this.buttonRef = React.createRef();
        return _this;
    }
    ActionButton.prototype.render = function () {
        var _this = this;
        return React.createElement("div", null,
            React.createElement(reactstrap_1.Button, { color: this.props.colour, innerRef: this.buttonRef, style: { width: "46px", height: "38px" }, onClick: function () {
                    Services_1.EventHandlerProvider.GetInstance().AddEvent(_this.props.Event);
                } }, this.props.MultipleIcons ?
                React.createElement("span", { className: "fa-layers fa-fw" },
                    React.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: this.props.Icons[1], transform: { x: -1 }, style: { fontSize: "1.5rem" } }),
                    React.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: this.props.Icons[0], transform: { y: -1 }, style: { fontSize: "0.6rem" } }))
                :
                    React.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: this.props.Icons, style: { fontSize: "1.5rem" } })),
            this.buttonRef !== undefined &&
                React.createElement(Components_1.TooltipX, { placement: "bottom", target: this.buttonRef }, this.props.TooltipText));
    };
    return ActionButton;
}(React.Component));
exports.ActionButton = ActionButton;
//# sourceMappingURL=ActionButton.js.map